import { connect } from 'react-redux'
import DeleteAddressComponent from '../components/DeleteAddress'
import {
  deleteAddress,
} from '../actions/ApiReqest'
import {
  hideDeleteAddressModal,
  clearDeleteErrorMessage,
} from '../actions'

const mapStateToProps = (state) => ({
  showDeleteModal: state.address.showDeleteAddressModal,
  showDeleteErrorMessage: state.address.delete.error,
  errorMessage: state.address.delete.message,
})

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => {
    dispatch(hideDeleteAddressModal())
    dispatch(clearDeleteErrorMessage())
  },
  onDelete: () => dispatch(deleteAddress()),
})

const DeleteAddress = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteAddressComponent)

export default DeleteAddress
